import { apiCall } from './gqlClient';

const GETSERVICESBYRESOURCE_QUERY = `
  query getServicesByResource($resourceId: Int!) {
    getServicesByResource(resourceId: $resourceId)
    {
      id
			svcTypeId
			svcGroupId
			providerId
			name
			description
			duration
			resolution
			timeUnit
			capacity
			price
			cancel
			recurring
			active
			archive
			orderIndex
			startTime
			endTime
			color
			pricing
			target
			sessionLimit
			type
			userHasMembership
			classesCounter
			subServicesCounter
			isAlwaysAvailable
			defaultTimeSlotStep
			activeClasses
			thumbnailUrl
			imageId
			preparationTime
			credits
      ...fragments
    }
  }`;

export const getServicesByResourceApiCall = async ({resourceId}, fragments = null) => apiCall({ query: GETSERVICESBYRESOURCE_QUERY, variables: {resourceId}, fragments });

const GETOFFERSBYRESOURCE_QUERY = `
  query getOffersByResource($resourceId: Int!) {
    getOffersByResource(resourceId: $resourceId)
    {
      id
			providerId
			serviceId
			name
			description
			startTime
			endTime
			duration
			capacity
			minimumCapacity
			price
			model
			sessionLimit
			active
			orderIndex
			sessionsCounter
			entityType
			locationType
			customerId
			preparationTime
			credits
      ...fragments
    }
  }`;

export const getOffersByResourceApiCall = async ({resourceId}, fragments = null) => apiCall({ query: GETOFFERSBYRESOURCE_QUERY, variables: {resourceId}, fragments });

const GETSERVICES_QUERY = `
  query getServices($type: String) {
    getServices(type: $type)
    {
      id
			svcTypeId
			svcGroupId
			providerId
			name
			description
			duration
			resolution
			timeUnit
			capacity
			price
			cancel
			recurring
			active
			archive
			orderIndex
			startTime
			endTime
			color
			pricing
			target
			sessionLimit
			type
			userHasMembership
			classesCounter
			subServicesCounter
			isAlwaysAvailable
			defaultTimeSlotStep
			activeClasses
			thumbnailUrl
			imageId
			preparationTime
			credits
      ...fragments
    }
  }`;

export const getServicesApiCall = async ({type}, fragments = null) => apiCall({ query: GETSERVICES_QUERY, variables: {type}, fragments });

const GETSERVICESCOURSESEVENTS_QUERY = `
  query getServicesCoursesEvents {
    getServicesCoursesEvents
    {
      id
			name
			type
			pricing
      ...fragments
    }
  }`;

export const getServicesCoursesEventsApiCall = async (fragments = null) => apiCall({ query: GETSERVICESCOURSESEVENTS_QUERY, variables: {}, fragments });

const GETSIMPLFIEDSERVICESSUBSERVICESCLASSES_QUERY = `
  query getSimplfiedServicesSubServicesClasses {
    getSimplfiedServicesSubServicesClasses
  }`;

export const getSimplfiedServicesSubServicesClassesApiCall = async () => apiCall({ query: GETSIMPLFIEDSERVICESSUBSERVICESCLASSES_QUERY, variables: {}});

const GETARCHIVEDSERVICES_QUERY = `
  query getArchivedServices($type: String) {
    getArchivedServices(type: $type)
    {
      id
			svcTypeId
			svcGroupId
			providerId
			name
			description
			duration
			resolution
			timeUnit
			capacity
			price
			cancel
			recurring
			active
			archive
			orderIndex
			startTime
			endTime
			color
			pricing
			target
			sessionLimit
			type
			userHasMembership
			classesCounter
			subServicesCounter
			isAlwaysAvailable
			defaultTimeSlotStep
			activeClasses
			thumbnailUrl
			imageId
			preparationTime
			credits
      ...fragments
    }
  }`;

export const getArchivedServicesApiCall = async ({type}, fragments = null) => apiCall({ query: GETARCHIVEDSERVICES_QUERY, variables: {type}, fragments });

const GETPROVIDERALLSERVICES_QUERY = `
  query getProviderAllServices($type: String) {
    getProviderAllServices(type: $type)
    {
      id
			svcTypeId
			svcGroupId
			providerId
			name
			description
			duration
			resolution
			timeUnit
			capacity
			price
			cancel
			recurring
			active
			archive
			orderIndex
			startTime
			endTime
			color
			pricing
			target
			sessionLimit
			type
			userHasMembership
			classesCounter
			subServicesCounter
			isAlwaysAvailable
			defaultTimeSlotStep
			activeClasses
			thumbnailUrl
			imageId
			preparationTime
			credits
      ...fragments
    }
  }`;

export const getProviderAllServicesApiCall = async ({type}, fragments = null) => apiCall({ query: GETPROVIDERALLSERVICES_QUERY, variables: {type}, fragments });

const GETPUBLICSERVICES_QUERY = `
  query getPublicServices($providerId: Int) {
    getPublicServices(providerId: $providerId)
    {
      id
			svcTypeId
			svcGroupId
			providerId
			name
			description
			duration
			resolution
			timeUnit
			capacity
			price
			cancel
			recurring
			active
			archive
			orderIndex
			startTime
			endTime
			color
			pricing
			target
			sessionLimit
			type
			userHasMembership
			classesCounter
			subServicesCounter
			isAlwaysAvailable
			defaultTimeSlotStep
			activeClasses
			thumbnailUrl
			imageId
			preparationTime
			credits
      ...fragments
    }
  }`;

export const getPublicServicesApiCall = async ({providerId}, fragments = null) => apiCall({ query: GETPUBLICSERVICES_QUERY, variables: {providerId}, fragments });

const GETPUBLICCOURSES_QUERY = `
  query getPublicCourses($providerId: Int) {
    getPublicCourses(providerId: $providerId)
    {
      id
			svcTypeId
			svcGroupId
			providerId
			name
			description
			duration
			resolution
			timeUnit
			capacity
			price
			cancel
			recurring
			active
			archive
			orderIndex
			startTime
			endTime
			color
			pricing
			target
			sessionLimit
			type
			userHasMembership
			classesCounter
			subServicesCounter
			isAlwaysAvailable
			defaultTimeSlotStep
			activeClasses
			thumbnailUrl
			imageId
			preparationTime
			credits
      ...fragments
    }
  }`;

export const getPublicCoursesApiCall = async ({providerId}, fragments = null) => apiCall({ query: GETPUBLICCOURSES_QUERY, variables: {providerId}, fragments });

const GETPUBLICEVENTS_QUERY = `
  query getPublicEvents($providerId: Int) {
    getPublicEvents(providerId: $providerId)
    {
      id
			svcTypeId
			svcGroupId
			providerId
			name
			description
			duration
			resolution
			timeUnit
			capacity
			price
			cancel
			recurring
			active
			archive
			orderIndex
			startTime
			endTime
			color
			pricing
			target
			sessionLimit
			type
			userHasMembership
			classesCounter
			subServicesCounter
			isAlwaysAvailable
			defaultTimeSlotStep
			activeClasses
			thumbnailUrl
			imageId
			preparationTime
			credits
      ...fragments
    }
  }`;

export const getPublicEventsApiCall = async ({providerId}, fragments = null) => apiCall({ query: GETPUBLICEVENTS_QUERY, variables: {providerId}, fragments });

const GETALLSERVICES_QUERY = `
  query getAllServices($providerId: Int) {
    getAllServices(providerId: $providerId)
    {
      id
			svcTypeId
			svcGroupId
			providerId
			name
			description
			duration
			resolution
			timeUnit
			capacity
			price
			cancel
			recurring
			active
			archive
			orderIndex
			startTime
			endTime
			color
			pricing
			target
			sessionLimit
			type
			userHasMembership
			classesCounter
			subServicesCounter
			isAlwaysAvailable
			defaultTimeSlotStep
			activeClasses
			thumbnailUrl
			imageId
			preparationTime
			credits
      ...fragments
    }
  }`;

export const getAllServicesApiCall = async ({providerId}, fragments = null) => apiCall({ query: GETALLSERVICES_QUERY, variables: {providerId}, fragments });

const GETALLCOURSES_QUERY = `
  query getAllCourses($providerId: Int) {
    getAllCourses(providerId: $providerId)
    {
      id
			svcTypeId
			svcGroupId
			providerId
			name
			description
			duration
			resolution
			timeUnit
			capacity
			price
			cancel
			recurring
			active
			archive
			orderIndex
			startTime
			endTime
			color
			pricing
			target
			sessionLimit
			type
			userHasMembership
			classesCounter
			subServicesCounter
			isAlwaysAvailable
			defaultTimeSlotStep
			activeClasses
			thumbnailUrl
			imageId
			preparationTime
			credits
      ...fragments
    }
  }`;

export const getAllCoursesApiCall = async ({providerId}, fragments = null) => apiCall({ query: GETALLCOURSES_QUERY, variables: {providerId}, fragments });

const GETALLEVENTS_QUERY = `
  query getAllEvents($providerId: Int) {
    getAllEvents(providerId: $providerId)
    {
      id
			svcTypeId
			svcGroupId
			providerId
			name
			description
			duration
			resolution
			timeUnit
			capacity
			price
			cancel
			recurring
			active
			archive
			orderIndex
			startTime
			endTime
			color
			pricing
			target
			sessionLimit
			type
			userHasMembership
			classesCounter
			subServicesCounter
			isAlwaysAvailable
			defaultTimeSlotStep
			activeClasses
			thumbnailUrl
			imageId
			preparationTime
			credits
      ...fragments
    }
  }`;

export const getAllEventsApiCall = async ({providerId}, fragments = null) => apiCall({ query: GETALLEVENTS_QUERY, variables: {providerId}, fragments });

const GETCOURSESANDEVENTS_QUERY = `
  query getCoursesAndEvents {
    getCoursesAndEvents
    {
      id
			svcTypeId
			svcGroupId
			providerId
			name
			description
			duration
			resolution
			timeUnit
			capacity
			price
			cancel
			recurring
			active
			archive
			orderIndex
			startTime
			endTime
			color
			pricing
			target
			sessionLimit
			type
			userHasMembership
			classesCounter
			subServicesCounter
			isAlwaysAvailable
			defaultTimeSlotStep
			activeClasses
			thumbnailUrl
			imageId
			preparationTime
			credits
      ...fragments
    }
  }`;

export const getCoursesAndEventsApiCall = async (fragments = null) => apiCall({ query: GETCOURSESANDEVENTS_QUERY, variables: {}, fragments });

const TOGGLESERVICESTATUS_QUERY = `
  mutation toggleServiceStatus($id: Int!, $status: Boolean!, $type: String!) {
    toggleServiceStatus(id: $id, status: $status, type: $type)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const toggleServiceStatusApiCall = async ({id, status, type}, fragments = null) => apiCall({ query: TOGGLESERVICESTATUS_QUERY, variables: {id, status, type}, fragments });

const PUBLISHALLSERVICECHILDREN_QUERY = `
  mutation publishAllServiceChildren($id: Int!, $type: String!) {
    publishAllServiceChildren(id: $id, type: $type)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const publishAllServiceChildrenApiCall = async ({id, type}, fragments = null) => apiCall({ query: PUBLISHALLSERVICECHILDREN_QUERY, variables: {id, type}, fragments });

const REORDERSERVICES_QUERY = `
  mutation reorderServices($type: String!, $oldPosition: Int!, $newPosition: Int!) {
    reorderServices(type: $type, oldPosition: $oldPosition, newPosition: $newPosition)
  }`;

export const reorderServicesApiCall = async ({type, oldPosition, newPosition}, ) => apiCall({ query: REORDERSERVICES_QUERY, variables: {type, oldPosition, newPosition}});

const SAVESERVICE_QUERY = `
  mutation saveService($request: ServiceCreateInput!) {
    saveService(request: $request)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const saveServiceApiCall = async ({request}, fragments = null) => apiCall({ query: SAVESERVICE_QUERY, variables: {request}, fragments });

const ARCHIVESERVICE_QUERY = `
  mutation archiveService($id: Int!) {
    archiveService(id: $id)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const archiveServiceApiCall = async ({id}, fragments = null) => apiCall({ query: ARCHIVESERVICE_QUERY, variables: {id}, fragments });

const RESTORESERVICE_QUERY = `
  mutation restoreService($id: Int!) {
    restoreService(id: $id)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const restoreServiceApiCall = async ({id}, fragments = null) => apiCall({ query: RESTORESERVICE_QUERY, variables: {id}, fragments });
